module.exports = __webpack_public_path__ + "static/img/id-card-back-sample.d0fe0aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/upload/id-card-back-sample.png
// module id = K57H
// module chunks = 4